module.exports = __webpack_public_path__ + "static/media/avalanche_token_round.3e178e42.png";